import React from 'react';
import '../style/generalTab.css'
import PolicyTabWording from "./ApplicationPolicy/policyTabWording";
import PolicyTabSchedule from "./ApplicationPolicy/policyTabSchedule";
import CenteredDots from "./General/centeredDots";
import FormResponseMessage from "./formResponseMessage";
import {downLoadFile} from "../helpers/functions";
import { CANADA_COUNTRY, COUNTRY } from '../helpers/variables';

const PolicyTab = (props) => {
    if (
        props.fetchingSchedules ||
        props.fetchingIpt ||
        props.fetchingUnderwriter ||
        props.fetchingSolicitorDetails ||
        props.fetchingPremiumSettings ||
        props.fetchingWording
    ) {
        return (
            <CenteredDots/>
        )
    }

    if(
        props.selectedApp.policyStatus === 'Draft'
        || props.selectedApp.policyStatus === 'Referred'
        || props.selectedApp.policyStatus === 'Rejected'
    ){
        return null;
    }

	return (
		<div className="generalTab-wrapper">
            {
                props.haveDataRequired && (
                    <PolicyTabSchedule
                        downloadPolicySchedule={props.downloadPolicySchedule}
                        applicationPolicyTrack={props.applicationPolicyTrack}
                        fetchingSchedules={props.fetchingSchedules}
                        fetchingIpt={props.fetchingIpt}
                        fetchingUnderwriter={props.fetchingUnderwriter}
                        fetchingSolicitorDetails={props.fetchingSolicitorDetails}
                        fetchingPremiumSettings={props.fetchingPremiumSettings}
                        haveDataRequired={props.haveDataRequired}
                        groupRangesOfDamages={props.groupRangesOfDamages}
                        ipt={props.ipt}
                        schedules={props.schedules}
                        underwriterName={props.policy.underwriterName}
                        footer={props.footer}
                        findQuestionAnswer={props.findQuestionAnswer}
                        applicationPremiumSettings={props.applicationPremiumSettings}
                        selectedApp={props.selectedApp}
                        lawsysFirm={props.lawsysFirm}
                        allPossibleDamages = {props.allPossibleDamages}
                        fetchingPolicy = {props.fetchingPolicySchedule}
                    />
                )
            }
            {
                !props.failedToGetWordingMsg && (
                    <div>
                        <PolicyTabWording
                            handleClick={props._downloadWording}
                            wordingFile={{name: `${props.wording.name}`}}
                            policyLiveDate={props.policy.liveDate}
                            aragReference={props.policy.aragReference}
                        />
                    {COUNTRY !== CANADA_COUNTRY && 
                        <PolicyTabWording
                            handleClick={() => downLoadFile(props.wording.ipidName, props.wording.ipidEncodedFile)}
                            wordingFile={{name: `${props.wording.ipidName}`}}
                            policyLiveDate={props.policy.liveDate}
                            aragReference={props.policy.aragReference}
                        />}
                    </div>
                )
            }
            {
                props.failedToGetWordingMsg && (
                    <FormResponseMessage
                        Message={props.failedToGetWordingMsg}
                        CenterWrapper="col-sm-12 mb-15 mt-15"
                        MessageStyle="formResponseMessage-reject" />
                )
            }
            {
                !props.haveDataRequired && (
                    <FormResponseMessage
                        LeftWrapper="col-sm-3"
                        CenterWrapper="col-sm-12 mt-15 mb-15"
                        MessageStyle="formResponseMessage-reject"
                        Message={'Failed to create policy schedule pdf file. Try again later.'}
                    />
                )
            }
		</div>
	)
};

export default PolicyTab;